<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Update Profile</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-text-field
              v-model="txtEmail"
              :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'Invalid E-mail format']"
              :counter="150"
              label="E-mail"
              required
            ></v-text-field>
            <v-select
              v-model="cboTitle"
              :items="titles"
              :rules="[v => !!v || 'Please select title']"
              label="Title"
              required
            ></v-select>
            <v-text-field
              v-model="txtFirstName"
              :rules="[v => !!v || 'First name is required']"
              :counter="50"
              label="First Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtLastName"
              :rules="[v => !!v || 'Last name is required']"
              :counter="50"
              label="Last Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtPhone"
              :counter="14"
              label="Handphone"
            ></v-text-field>
            <v-select
              v-model="cboTimezone"
              :items="timezones"
              :rules="[v => !!v || 'Please select timezone']"
              label="Timezone"
              required
            ></v-select>
            <v-btn
              block
              large
              color="primary"
              :disabled="!frmValid"
              @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data: () => ({
    drawer: false,
    loading: false,
    frmValid: true,
    txtEmail: '',
    titles: ['Mr', 'Ms'],
    cboTitle: '',
    txtFirstName: '',
    txtLastName: '',
    txtPhone: '',
    timezones: [
      '+00:00',
      '+01:00',
      '+02:00',
      '+03:00',
      '+03:30',
      '+04:00',
      '+04:30',
      '+05:00',
      '+05:30',
      '+05:45',
      '+06:00',
      '+06:30',
      '+07:00',
      '+08:00',
      '+08:45',
      '+09:00',
      '+09:30',
      '+10:00',
      '+10:30',
      '+11:00',
      '+12:00',
      '+12:45',
      '+13:00',
      '+14:00',
      '-01:00',
      '-02:00',
      '-03:00',
      '-03:30',
      '-04:00',
      '-05:00',
      '-06:00',
      '-07:00',
      '-08:00',
      '-09:00',
      '-09:30',
      '-10:00',
      '-11:00',
      '-12:00'
    ],
    cboTimezone: ''
  }),

  mounted () {
    this.openDrawerForDesktop()
    this.getMyProfile()
    this.disableBottomDetector()
  },

  methods: {
    getMyProfile: function (adminId) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/me')
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.txtEmail = resp.data.data.loginEmail
            this.cboTitle = resp.data.data.title
            this.txtFirstName = resp.data.data.firstName
            this.txtLastName = resp.data.data.lastName
            this.txtPhone = resp.data.data.phone
            this.cboTimezone = resp.data.data.gmtTimezone
          } else {
            console.log('unable to load my details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=/me/profile')
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/me', {
          loginEmail: this.txtEmail,
          title: this.cboTitle,
          firstName: this.txtFirstName,
          lastName: this.txtLastName,
          phone: this.txtPhone,
          gmtTimezone: this.cboTimezone
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.$store.dispatch('UPDATE_PROFILE')
              window.alert('Profile is updated')
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=/me/profile')
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    }
  }
}
</script>
